/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useLayoutEffect, useState } from "react";
import bgImage from "../../assets/images/img-bg-full.png";
import { Blank, Div, EvBorderButton, EvButton, Font, Form, Img, Input } from "../../styles/commonStyle";
import { noticeRedColor, orangeBtnGradient, primaryColor } from "../../styles/theme";
import { FontLink, IntegratedFont, IntegratedRegistLink, LoginBox, LoginLayout } from "./style";
import EvModal from "../../components/modal";
import { useRecoilState } from "recoil";
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { loginValidation } from "../../validation";
import { RESULT, ResponseModel } from "../../model/response";
import usePost from "../../hooks/usePost";
import crypto from "crypto-es";
import Loading from "../../components/loading/loading";
import { errorState, evWhereMemberState, isEvWhereMemberState, loadingState, loginState, modalState, modalTypeState, userRegistIngState, userSocialRegistState, variableState } from "../../recoil/atoms";
import { loginPostSelector } from "../../recoil/variableAtom";
import { AppleButton, GoogleButton, SocialKakao } from "../../components/socialButton/socialButton";
import { useKakaoLogin } from "../../hooks/useKakaoLogin";
import integrateBannerLogin from "../../assets/images/integrate-banner-login.png";

function LoginPage() {
  const navigate = useNavigate();
  const [modalType, setModalType] = useRecoilState(modalTypeState);
  const [isModalOpen, setModalOpen] = useRecoilState(modalState);
  const [islogin, setlogin] = useRecoilState(loginState);
  const [isLoading, setLoading] = useRecoilState(loadingState);
  let sessionStorage = window.sessionStorage;
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(loginValidation),
    reValidateMode: "onBlur",
    mode: "onSubmit",
  });
  const [body, setBody] = useState<any>();
  const [evWhereMember, setEvWhereMember] = useRecoilState(evWhereMemberState);
  const [isEvWhereMember, setIsEvWhereMember] = useRecoilState(isEvWhereMemberState);
  const [userSocialRegist, setUserSocialRegist] = useRecoilState(userSocialRegistState);
  const [errMsg, setErrMsg] = useRecoilState(errorState);
  const response: ResponseModel<any> = usePost({
    recoilSelector: loginPostSelector,
    data: body,
    recoilState: variableState,
  });
  useLayoutEffect(() => {
    setUserSocialRegist(undefined);
  }, []);
  useEffect(() => {
    if (response?.result === RESULT.OK) {
      setlogin(true);
      sessionStorage.setItem("accessToken", response.data.accessToken);
      sessionStorage.setItem("refreshToken", response.data.refreshToken);
      sessionStorage.setItem("id", body.lgnId);
      let password = crypto.AES.encrypt(body.lgnPassword, process.env.REACT_APP_JWT_ACCESS_SECRET_KEY).toString();
      sessionStorage.setItem("check", password);
      if (body.ssbyp) {
        sessionStorage.setItem("ssbyp", body.ssbyp);
      }
      navigate("/");
    }
    if (response?.result === RESULT.FAIL) {
      setModalType("inputError");
      if (evWhereMember?.ssbyp == 'google' || evWhereMember?.ssbyp == 'kakao' || evWhereMember?.ssbyp == 'apple') {
        setUserSocialRegist({
          lgn_Id: evWhereMember?.lgn_Id,
          ssbyp: evWhereMember?.ssbyp,
          idToken: evWhereMember?.idToken,
        });
        setEvWhereMember(undefined);
        navigate("/register");
      } else {
        setErrMsg(response.msg!);
        setModalOpen(true);
        setEvWhereMember(undefined);
        setUserSocialRegist(undefined);
      }
    }
  }, [response]);

  function modalHandler(type: string) {
    setModalType(type);
    setModalOpen(true);
  }
  useEffect(() => {
    setEvWhereMember(undefined);
  }, [navigate]);
  async function OnSubmit(data: any) {
    setBody({
      lgnId: data.lgnId.toString(),
      lgnPassword: data.lgnPassword,
    });
  }

  useEffect(() => {
    if (evWhereMember) {
      var ssbypCode;
      if (evWhereMember.ssbyp == 'google') {
        ssbypCode = '02';
      } else if (evWhereMember.ssbyp == 'kakao') {
        ssbypCode = '03';
      } else if (evWhereMember.ssbyp == 'apple') {
        ssbypCode = '04';
      }
      setBody({
        lgnId: evWhereMember?.lgn_Id,
        lgnPassword: evWhereMember?.lgnPassword,
        ssbyp: ssbypCode,
      });
    }
  }, [evWhereMember]);

  useKakaoLogin();

  useEffect(() => {
    // URL에서 인증 코드 추출
    const code = new URLSearchParams(window.location.search).get('code');

    if (code && window.opener) {
      // 부모 창으로 인증 코드 전달
      window.opener.postMessage({ type: 'KAKAO_LOGIN_SUCCESS', code }, window.location.origin);
      // 팝업 창 닫기
      window.close();
    }
  }, []);

  let idError = errors.lgnId ? errors.lgnId.message : undefined;
  let pwError = errors.lgnPassword ? errors.lgnPassword.message : undefined;
  return (
    <LoginLayout bgImg={bgImage}>
      <LoginBox>
        <Font fontSize="1.75rem" fontWeight="500">
          로그인
        </Font>
        <Blank height="24px" />
        <IntegratedRegistLink to="/register">
          <Img width="100%" style={{ filter: 'drop-shadow(0 2px 4px rgba(0, 0, 0, 0.25))' }} src={integrateBannerLogin} alt="integrateBannerLogin" />
        </IntegratedRegistLink>
        <Blank height="24px" />
        <Form onSubmit={handleSubmit(OnSubmit)} className="w-full">
          <Div className="flex w-full">
            <Div className="flex flex-col w-full">
              <Input
                placeholder="아이디"
                className="mb-[-1px]"
                fontSize="calc(0.9rem + 0.3vw)"
                padding="10px"
                tabIndex={1}
                type="text"
                {...register("lgnId")}
                name="lgnId"
                isError={idError ? true : false}
              />
              <Input
                placeholder="비밀번호"
                fontSize="calc(0.9rem + 0.3vw)"
                padding="10px"
                tabIndex={2}
                type="password"
                {...register("lgnPassword")}
                name="lgnPassword"
                autoComplete="off"
                isError={pwError ? true : false}
              />
            </Div>
            <EvButton
              bgColor={primaryColor}
              noRadius={true}
              color="#FFF"
              className="w-[calc(6rem + 1vw)]"
              fontSize="calc(1rem + 0.5vw)"
              changeFontSize="calc(1rem + 0.5vw)"
              fontweight="400"
            >
              로그인
            </EvButton>
          </Div>
        </Form>
        <Font color={noticeRedColor} className="w-[100%]" fontSize="calc(0.7rem + 0.3vw)">
          {idError || pwError ? "필수입력입니다." : null}
        </Font>
        <Blank height="16px" />
        <Div className="flex justify-end items-center w-full">
          <Div className="flex items-center">
            <FontLink onClick={() => modalHandler("id")}>아이디찾기</FontLink>
            <Blank width="4px" /> | <Blank width="4px" />
            <FontLink onClick={() => modalHandler("password")}>비밀번호찾기</FontLink>
          </Div>
        </Div>
        <Div className="flex flex-col items-center" style={{ gap: "16px" }}>
          <Font fontSize="14px" fontWeight="500">SNS 로그인</Font>
          <Div className="flex justify-center items-center" style={{ gap: "24px" }}>
            <SocialKakao />
            <GoogleButton />
            <AppleButton />
          </Div>
        </Div>
      </LoginBox>
      <EvModal type={modalType} />
      <Loading isLoading={isLoading} />
    </LoginLayout>
  );
}

export default LoginPage;
